<script setup>
  import { useWebStore } from "~/store/web";
  import { useScrollToComponent } from "~/composables/useScrollToComponent";

  const store=useWebStore();
  const { scrollToComponent } = useScrollToComponent();

  const route = useRoute();
  route.path.split('/')[1]!==store.chosenLang&&store.setLanguage(route.path.split('/')[1])
  store.chosenTab = store.sites[2].url
  
  const productGroups=store.getProductTypes('buckets')

  const products=store.getProducts({category:'buckets'})

</script>
<template>
  <div class="blowingMachineMainView">
    <banner-carousel
        :slides="[
            {title:store.getLocaleString('bpb1'), subtitle: store.getLocaleString('bpb2'), image:'banyakanal_banner.webp'},
            {title:store.getLocaleString('bpb3'), subtitle: store.getLocaleString('bpb4'), image:'2500x400_magasurites.webp'}
        ]"
        card-width="800px"
    />
    <areas-carousel
        :slides="productGroups"
        @clickedOnSlide="scrollToComponent"
        :wrap="true"
        :items-to-show="store.getAreaBannerSlidesToShow()"
    />
    <enquiry-button @click="scrollToComponent('enquiry')"/>
    <h1 class="InterExtraBold text-3xl mt-8 md:text-4xl lg:text-5xl">{{ store.sites[2].text }}</h1>
    <title-text-image-template
        class="my-11"
        :annotation="store.getLocaleString('bptti1')"
        :title="store.getLocaleString('bptti2')"
        :text0="store.getLocaleString('bptti3')"
        :text1="store.getLocaleString('bptti4')"
        image="Kanalgyartas_1400x600.webp"
    />

    <div class="p-5">
      <catalog-button :text="store.getLocaleString('h19')" :file="store.getLocaleString('l21')"/>
    </div>

    <h3 class="ls-03 text-xl lg:text-3xl mt-16 xl:text-4xl 2xl:text-5xl InterExtraBold">{{store.getLocaleString('bp1')}}</h3>

    <div v-for="group in productGroups" v-bind:key="group.title"  class="tr-smooth-border productGroup w-full xl:w-3/4 xl:mx-auto" :id="group.id">
      <h4 class="mx-auto text-xl uppercase text-left mt-20 mb-1 InterExtraBold sm:ml-7 xl:text-2xl" style="width: fit-content;">{{group.name}}</h4>
      <div class="grid grid-cols-2 auto-rows-fr p-1 gap-4 mt-1 sm:grid-cols-3 xl:gap-10 xl:mb-7 2xl:grid-cols-4">
        <Product v-for="prod in products.filter((n) => n.type === group.id)"
                v-bind:key="prod.id"
                :name="prod.name"
                :image="prod.image"
                :text="prod.usage"
                :enquiry-text="store.locale.current.bpb5"
                :productPage="true"
                :id="prod.id"
        />
      </div>
    </div>
    <ContactUsPage title="Keressen minket!"
                   subtitle="Forduljon hozzánk bizalommal"
                   contact-phone="06 20 342 2988"
                   contact-email="tosi.janos@poliol.hu"
                   contact-topic="attachment-general"
    />

    <CustomCarousel :no-of-slides="2.5" bordered="false" :slides="['medikemia-logo.webp','szentkiralyi_logo.webp','fantana-mare_logo.webp','resilux_logo.webp','royalsekt_logo.webp','florin_logo.webp','caola_logo.webp']"/>
    <footer-comp/>
  </div>
</template>

<style scoped lang="scss">
  .blowingMachineMainView{
    padding: unset;
    width: 100%;
  }
  .productGroup{
    position: relative;
  }
  .productGroup::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid transparent;
    transition: border 0.8s ease-in-out;
  }

</style>